var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDusch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    "data-name": "Lager 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.53 60.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 { fill:#fff; stroke-linejoin: round; }\n      .cls-1, .cls-2 { stroke: #000; stroke-width: 0.85px; }\n      .cls-2 { fill:#fff; stroke-miterlimit: 11.34; }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g969"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rect951",
    className: "cls-1",
    x: 0.43,
    y: 0.43,
    width: 59.61,
    height: 59.61
  }), /*#__PURE__*/React.createElement("path", {
    id: "path953",
    className: "cls-2",
    d: "M2.38,4.31l17.9,17.9",
    transform: "translate(-1.97 -3.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path955",
    className: "cls-2",
    d: "M44.23,46.22,62.14,64.13",
    transform: "translate(-1.97 -3.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path957",
    className: "cls-2",
    d: "M62.2,4.31l-18,17.9",
    transform: "translate(-1.97 -3.9)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path959",
    className: "cls-2",
    d: "M20.28,46.22,2.38,64.13",
    transform: "translate(-1.97 -3.9)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "path961",
    className: "cls-2",
    cx: 30.34,
    cy: 30.34,
    r: 4.42
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDusch);
export default __webpack_public_path__ + "static/media/dusch.940b877aab15c3b0f0debb1501ca7c9b.svg";
export { ForwardRef as ReactComponent };